import { useEffect, useState } from 'react'
import {
  isRolloutPlanSettled,
  subscribeToRolloutPlanSettled,
} from 'lib/splitRolloutPlan'

/**
 * Reactive wrapper around isRolloutPlanSettled(). Re-renders when the
 * consent-denied splitChanges fetch settles (success, non-OK, or timeout).
 * Reads the live module flag each render so mocked or newly-settled values
 * are visible without waiting for the next poll tick.
 */
const useIsRolloutPlanSettled = (): boolean => {
  const [, forceRerender] = useState(0)
  const settled = isRolloutPlanSettled()

  useEffect(() => {
    const unsubscribe = subscribeToRolloutPlanSettled(() => {
      forceRerender((tick) => tick + 1)
    })

    // Settlement can happen between render and this effect.
    if (isRolloutPlanSettled() !== settled) {
      forceRerender((tick) => tick + 1)
    }

    return unsubscribe
  }, [])

  return settled
}

export default useIsRolloutPlanSettled
